export default function generateSortQuery(sortOrder: String | false, delimiter: String): string {
  if (sortOrder === 'build_desc' || sortOrder === 'build_asc' || sortOrder === 'point_desc') {
    return `${delimiter}sort=${sortOrder}`;
  }
  return '';
}
